import {
  request
} from "./request";

export function getGeneInfoByGenename(genename) {
  return request({
    url: '/ascancer/api/geneinfo/genename/',
    params: {
      genename
    }
  })
}

export function getGencodeGenePatternByGenename(genename) {
  return request({
    url: '/ascancer/api/gencode/genename/',
    params: {
      genename
    }
  })
}

export function getPsiMetaByGenenameAndCancertype(genename, cancertype) {
  return request({
    url: '/ascancer/api/psi',
    params: {
      genename,
      cancertype,
    }
  })
}